module.exports = __webpack_public_path__ + "img/list_Story_01.a1d19571.jpeg";